import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { RevitDataProvider } from './shared/providers/RevitDataContext';
import { ActiveDocumentProvider } from './shared/hooks/ActiveDocumentProvider';
import { ThemeProviderWrapper } from './shared/providers/ThemeContext';
import ErrorBoundary from './app/AppErrorBoundary';
import AppContent from './AppContent';
import { SuperAdminGuard, SuperAdminPage, UserErrorsPage } from './features/super-admin';
import { startWebLogger, stopWebLogger } from './shared/api/grpc/webLogger';
import { OperationProgressWindowHost } from './shared/ui/progress';

// Start file logger immediately
startWebLogger();

function App() {
  useEffect(() => {
    return () => stopWebLogger();
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ThemeProviderWrapper>
          <CssBaseline />
          <OperationProgressWindowHost />
          <Routes>
            <Route
              path="/super-admin/user-errors"
              element={
                <SuperAdminGuard>
                  <UserErrorsPage />
                </SuperAdminGuard>
              }
            />
            <Route
              path="/super-admin"
              element={<Navigate replace to="/super-admin/dashboard" />}
            />
            <Route
              path="/super-admin/*"
              element={
                <SuperAdminGuard>
                  <SuperAdminPage />
                </SuperAdminGuard>
              }
            />
            <Route
              path="*"
              element={
                <RevitDataProvider>
                  <ActiveDocumentProvider>
                    <AppContent />
                  </ActiveDocumentProvider>
                </RevitDataProvider>
              }
            />
          </Routes>
        </ThemeProviderWrapper>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
